import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import klarnaService from "../services/klarnaService";

export const generateOrder = createAsyncThunk(
  "klarna/generateOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await klarnaService.generateOrder(orderId);
      setTimeout(()=>{
        var checkoutContainer = document.getElementById('my-checkout-container')
        checkoutContainer.innerHTML = response.data
         var scriptsTags = checkoutContainer.getElementsByTagName('script')
        // console.log(htmlSnippet);
        // // This is necessary otherwise the scripts tags are not going to be evaluated
         for (var i = 0; i < scriptsTags.length; i++) {
             var parentNode = scriptsTags[i].parentNode
              var newScriptTag = document.createElement('script')
             newScriptTag.type = 'text/javascript'
              newScriptTag.text = scriptsTags[i].text
              parentNode.removeChild(scriptsTags[i])
             parentNode.appendChild(newScriptTag)
         }
  
      })
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

const klarnaSlice = createSlice({
  name: "klarna",
  initialState: {
    order: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(generateOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.order = action.payload;
      })
      .addCase(generateOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default klarnaSlice.reducer;
